import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/building-scalable-edtech/page.tsx");
